module.exports = __webpack_public_path__ + "img/solution-farmer-img3.68458c93.png";